// leave blank for localhost

const addr = process.env.REACT_APP_API_SERVER_ADDR;

export default addr;
